import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2",
      d: "M12 2v2m0 16v2M4.929 4.929l1.414 1.414m11.314 11.314 1.414 1.414M2 12h2m16 0h2M6.343 17.657 4.93 19.07M19.07 4.93l-1.414 1.414M16 12a4 4 0 1 1-8 0 4 4 0 0 1 8 0"
    }, null, -1)
  ])))
}
export default { render: render }